export default __webpack_public_path__ + "static/media/user-default-avatar.2927eac7.png";